export enum Sources {
  Upload = 'upload',
  Unsplash = 'unsplash',
  Icon = 'icon',
}

export const defaultPosition = 'bottom-start';
